import { jsx as r } from "react/jsx-runtime";
import { Button as t } from "../../../Button/Button.mjs";
import "../../../Button/IconButton.mjs";
import "../../../Button/ButtonGroup.mjs";
import { ArrowUpFromBracketIcon as i } from "../../../../icons/componentIcons.mjs";
const p = ({ ...o }) => /* @__PURE__ */ r(
  t,
  {
    size: "md",
    variant: "secondary",
    rightIcon: /* @__PURE__ */ r(i, { size: "md", variant: "light" }),
    ...o,
    children: "Upload All"
  }
);
export {
  p as default
};
